var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        _vm._l(_vm.items, function (item, index) {
          return _vm.activeItem === index
            ? _c(
                "div",
                {
                  key: "item_" + index,
                  staticClass: "img-background",
                  style: "background-image: url(" + item.imgUrl + ")",
                },
                [
                  _c("div", { staticClass: "filter-gray" }),
                  _vm._v(" "),
                  _vm.loadingVideo
                    ? _c("div", { staticClass: "lds-ring" }, [
                        _c("div"),
                        _vm._v(" "),
                        _c("div"),
                        _vm._v(" "),
                        _c("div"),
                        _vm._v(" "),
                        _c("div"),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "swiper-over-container" }, [
          _c(
            "div",
            {
              staticClass: "custom-loader",
              class: _vm.loaderClass,
              on: {
                click: function ($event) {
                  return _vm.stopTimer()
                },
              },
            },
            [
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _vm.showStopTimer
                ? _c("span", { staticClass: "icon-close" })
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-container home-focus-swiper" }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.items, function (item, index) {
                return _c("div", { staticClass: "swiper-slide" }, [
                  _c("div", { staticClass: "wrap-content" }, [
                    _c("a", {
                      staticClass: "titre",
                      attrs: { href: item.url },
                      domProps: { innerHTML: _vm._s(item.titre) },
                    }),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "desc",
                      domProps: { innerHTML: _vm._s(item.extrait) },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "icon-arrow-right" }),
                  ]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wrap-bar" }),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tv" }, [
      _c("div", { staticClass: "filter-gray" }),
      _vm._v(" "),
      _c("div", { staticClass: "screen mute", attrs: { id: "tv" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }